import { render } from "./FormGenerateCode.vue?vue&type=template&id=ebd8a720&bindings={\"text\":\"data\",\"imageSize\":\"data\",\"imageSrc\":\"data\",\"generateQrCodeImage\":\"options\"}"
import script from "./FormGenerateCode.vue?vue&type=script&lang=js"
export * from "./FormGenerateCode.vue?vue&type=script&lang=js"
script.render = render

export default script